import IconNoInfosBase from 'assets/icons/noInfosBase.svg'
import IconNoInfosSection from 'assets/icons/noInfosSection.svg'
import IconTimeoutBase from 'assets/icons/baseTimeoutIcon.svg'

import { type AuthDataTypes } from 'context/AuthContext'

export const getAge = (date: string | undefined) => {
  if (date === undefined) return date

  const today = new Date()
  let birthDate = new Date(date)

  if (date.split('-')[2].length > 2) {
    const newDateFormatted = date.split('-').reverse().join('-')

    birthDate = new Date(newDateFormatted)
  }

  let age = today.getFullYear() - birthDate.getFullYear()
  const m = today.getMonth() - birthDate.getMonth()

  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--
  }

  return age
}

export const capitalize = (word: string) => {
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
}

export const isNumeric = (val: string) => {
  return /^-?\d+$/.test(val)
}

export const isEmptyObject = (object: object) => {
  if (object === null || object === undefined) return true
  return Object.keys(object).length === 0
}

export function splitString(stringToSplit: string, separator: string) {
  const arrayOfStrings = stringToSplit?.split(separator)

  const lastString = arrayOfStrings[arrayOfStrings.length - 1]

  return lastString
}

export function getOverlayCustomTooltip(contrastIsSelected: boolean) {
  return {
    ...(contrastIsSelected && {
      border: '1px solid var(--contrast-foreground-color)',
    }),
    borderRadius: '10px',
    padding: '0',
  }
}

export function hasImage(authData: AuthDataTypes): boolean {
  console.log('authDasta', authData)
  if (authData?.user?.image === '' || authData?.user?.image === undefined) return false
  const parts = authData.user.image.split(',')
  const hasPrefix = parts.length > 1 && parts[1] !== ''

  if (hasPrefix) {
    return true
  } else {
    return false
  }
}

export function isChild(age: number | undefined) {
  if (age === undefined) return false
  return age > 0 && age <= 12
}

export function decideIconSrcAtNoDataInfo(
  basesWithoutData: string[],
  basesWithTimeout: string[],
  base: string
) {
  if (basesWithoutData.includes(base)) {
    if (basesWithTimeout.includes(base)) {
      return IconTimeoutBase
    }
    return IconNoInfosBase
  }
  return IconNoInfosSection
}

export function decideTitleAtNoDataInfo(
  basesWithoutData: string[],
  basesWithTimeout: string[],
  base: string,
  section: string
) {
  if (basesWithoutData.includes(base)) {
    if (basesWithTimeout.includes(base)) {
      return 'Base indisponível no momento'
    }
    return 'A família não está nesta base'
  }
  return (
    <>
      A seção <strong>{section}</strong> não existe nesta base
    </>
  )
}

// função que destaca o "input" dentro da uma tag span, caso ele exista no "text". Ele retorna o texto original, com o destaque
export const highlightString = (text: string, input: string) => {
  const match = text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .match(
      input
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
    )
  if (match?.index !== undefined)
    return (
      <>
        {text.slice(0, match.index)}
        <span>{text.slice(match.index, match.index + match[0].length)}</span>
        {text.slice(match.index + input.length)}
      </>
    )
  return text
}
